/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { CreateIpAddressWhitelistRequest } from '../model/createIpAddressWhitelistRequest';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { GetIpAddressWhitelistsResponse } from '../model/getIpAddressWhitelistsResponse';
import type { IpAddressWhitelist } from '../model/ipAddressWhitelist';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import type { UpdateIpAddressWhitelistRequest } from '../model/updateIpAddressWhitelistRequest';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Get IP address whitelist
 */
export const useGetIpAddressWhitelistsHook = () => {
  const getIpAddressWhitelists =
    useCustomClient<GetIpAddressWhitelistsResponse>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getIpAddressWhitelists(
      { url: `/api/js/ip_address_whitelists`, method: 'GET', signal },
      options
    );
  };
};

export const getGetIpAddressWhitelistsQueryKey = () => {
  return [`/api/js/ip_address_whitelists`] as const;
};

export const useGetIpAddressWhitelistsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIpAddressWhitelistsQueryKey();

  const getIpAddressWhitelists = useGetIpAddressWhitelistsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>
  > = ({ signal }) => getIpAddressWhitelists(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetIpAddressWhitelistsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>
>;
export type GetIpAddressWhitelistsQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get IP address whitelist
 */
export const useGetIpAddressWhitelists = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetIpAddressWhitelistsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetIpAddressWhitelistsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIpAddressWhitelistsQueryKey();

  const getIpAddressWhitelists = useGetIpAddressWhitelistsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>
  > = ({ signal }) => getIpAddressWhitelists(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetIpAddressWhitelistsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>
>;
export type GetIpAddressWhitelistsSuspenseQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get IP address whitelist
 */
export const useGetIpAddressWhitelistsSuspense = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetIpAddressWhitelistsHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetIpAddressWhitelistsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Add IP address to whitelist
 */
export const useCreateIpAddressWhitelistHook = () => {
  const createIpAddressWhitelist = useCustomClient<IpAddressWhitelist>();

  return (
    createIpAddressWhitelistRequest: BodyType<CreateIpAddressWhitelistRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return createIpAddressWhitelist(
      {
        url: `/api/js/ip_address_whitelists`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createIpAddressWhitelistRequest,
      },
      options
    );
  };
};

export const useCreateIpAddressWhitelistMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateIpAddressWhitelistHook>>>,
    TError,
    { data: BodyType<CreateIpAddressWhitelistRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateIpAddressWhitelistHook>>>,
  TError,
  { data: BodyType<CreateIpAddressWhitelistRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const createIpAddressWhitelist = useCreateIpAddressWhitelistHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateIpAddressWhitelistHook>>>,
    { data: BodyType<CreateIpAddressWhitelistRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createIpAddressWhitelist(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateIpAddressWhitelistMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateIpAddressWhitelistHook>>>
>;
export type CreateIpAddressWhitelistMutationBody =
  BodyType<CreateIpAddressWhitelistRequest>;
export type CreateIpAddressWhitelistMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse
>;

/**
 * @summary Add IP address to whitelist
 */
export const useCreateIpAddressWhitelist = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateIpAddressWhitelistHook>>>,
    TError,
    { data: BodyType<CreateIpAddressWhitelistRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = useCreateIpAddressWhitelistMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Update IP address whitelist entry
 */
export const useUpdateIpAddressWhitelistHook = () => {
  const updateIpAddressWhitelist = useCustomClient<IpAddressWhitelist>();

  return (
    id: string,
    updateIpAddressWhitelistRequest: BodyType<UpdateIpAddressWhitelistRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return updateIpAddressWhitelist(
      {
        url: `/api/js/ip_address_whitelists/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateIpAddressWhitelistRequest,
      },
      options
    );
  };
};

export const useUpdateIpAddressWhitelistMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateIpAddressWhitelistHook>>>,
    TError,
    { id: string; data: BodyType<UpdateIpAddressWhitelistRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateIpAddressWhitelistHook>>>,
  TError,
  { id: string; data: BodyType<UpdateIpAddressWhitelistRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const updateIpAddressWhitelist = useUpdateIpAddressWhitelistHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateIpAddressWhitelistHook>>>,
    { id: string; data: BodyType<UpdateIpAddressWhitelistRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateIpAddressWhitelist(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateIpAddressWhitelistMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateIpAddressWhitelistHook>>>
>;
export type UpdateIpAddressWhitelistMutationBody =
  BodyType<UpdateIpAddressWhitelistRequest>;
export type UpdateIpAddressWhitelistMutationError = ErrorType<
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Update IP address whitelist entry
 */
export const useUpdateIpAddressWhitelist = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateIpAddressWhitelistHook>>>,
    TError,
    { id: string; data: BodyType<UpdateIpAddressWhitelistRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = useUpdateIpAddressWhitelistMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Delete IP address from whitelist
 */
export const useDeleteIpAddressWhitelistHook = () => {
  const deleteIpAddressWhitelist = useCustomClient<void>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return deleteIpAddressWhitelist(
      { url: `/api/js/ip_address_whitelists/${id}`, method: 'DELETE' },
      options
    );
  };
};

export const useDeleteIpAddressWhitelistMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteIpAddressWhitelistHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteIpAddressWhitelistHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const deleteIpAddressWhitelist = useDeleteIpAddressWhitelistHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteIpAddressWhitelistHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteIpAddressWhitelist(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteIpAddressWhitelistMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeleteIpAddressWhitelistHook>>>
>;

export type DeleteIpAddressWhitelistMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Delete IP address from whitelist
 */
export const useDeleteIpAddressWhitelist = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteIpAddressWhitelistHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = useDeleteIpAddressWhitelistMutationOptions(options);

  return useMutation(mutationOptions);
};
